import React from "react";
import { CiInstagram } from "react-icons/ci";
import { FaFacebook, FaLinkedin } from "react-icons/fa";
import logo from "../../assets/logo.png"
import { useNavigate } from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();
    let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };
    return (
        <footer className="bg-bgcolor text-white border-t border-gray-200 font-basefont">
            <div className="max-w-7xl mx-auto px-10 py-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
                <div>
                    {/* <h3 className="font-semibold text-lg mb-4 text-left">PG Overseas Private Limited</h3> */}
                    <img src={logo} className="h-26 w-48 justify-center align-center lg:mt-12 " alt="logo" />
                </div>
                <div>
                    <h3 className="font-bold mb-4 text-left">COMPANY</h3>
                    <ul className="space-y-3 text-md text-left cursor-pointer">
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/about`)}
                            >About us</p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/testimonials`)}
                            >
                                Testimonials</p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/faq`)}
                            >FAQ</p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/privacy-policy`)}
                            >Privacy Policy</p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/terms-and-conditions`)}
                            >Terms of Service</p>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 className="font-bold mb-4 text-left">SERVICES</h3>
                    <ul className="space-y-3 text-md text-left cursor-pointer">
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/services/import-export-services`)}
                            >Import/Export Services</p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/services/migration-services`)}
                            >Migration Services</p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/services/residency-by-investment`)}
                            >Residency by Investment </p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/services/business-buy-sale-services`)}
                            > Business Buy/Sale Services </p>
                        </li>
                        <li className="hover:underline hover:text-lightcolor">
                            <p
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/services/real-estate`)}
                            >Real Estate</p>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 className="font-bold mb-4 text-left">Follow Us</h3>
                    <div className="flex flex-wrap gap-4 text-2xl cursor-pointer">

                        <a
                            href="https://www.instagram.com/pgoverseasservices/profilecard/?igsh=MTlycDNwaTg5eTd4aw=="
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <CiInstagram className="hover:text-lightcolor" />
                        </a>
                         <a
                            href="https://www.linkedin.com/company/pg-overseas-services/about/?viewAsMember=true"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaLinkedin className="hover:text-lightcolor" />
                        </a>
                        
                    </div>
                </div>
            </div>

            <div className="border-t border-gray-200 py-4">
                <div className="max-w-7xl mx-auto px-10 flex flex-col md:flex-row justify-between items-center">
                    <div className="flex items-center space-x-4">
                        <span className="text-black text-sm font-medium">© {getYear()} PG Overseas Services </span>
                    </div>
                    <div className="flex flex-wrap justify-center cursor-pointer md:justify-end space-x-4 text-sm mt-4 md:mt-0">
                        <span>
                            Technology Partner - <a className="hover:underline hover:text-lightcolor" href="/" rel="noreferrer">Making Minds</a>
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
